import React from "react";
import { Carousel } from "@material-tailwind/react";
import zdjecie1 from "./zdjecia/o-nas/naszteatr1.jpg";
import zdjecie2 from "./zdjecia/o-nas/naszteatr3.jpg";
import zdjecie3 from "./zdjecia/o-nas/naszteatr5.jpg";

const Naszteatr = () => {
  return (
    <div className="bg-[#111111] py-16 px-4 sm:px-8 lg:px-16 xl:px-40">
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-center text-white mb-3 tracking-widest uppercase">
        Nasze cienie
      </h1>
      <div className="w-16 h-px bg-red-500 mx-auto mb-12" />

      <div className="max-w-3xl mx-auto rounded-xl overflow-hidden border border-white/10">
        <Carousel
          navigation={({ setActiveIndex, activeIndex, length }) => (
            <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
              {new Array(length).fill("").map((_, i) => (
                <span
                  key={i}
                  className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                    activeIndex === i ? "w-8 bg-red-400" : "w-4 bg-white/30"
                  }`}
                  onClick={() => setActiveIndex(i)}
                />
              ))}
            </div>
          )}
        >
          <img src={zdjecie1} alt="Nasze cienie 1" className="h-full w-full object-cover" />
          <img src={zdjecie2} alt="Nasze cienie 2" className="h-full w-full object-cover" />
          <img src={zdjecie3} alt="Nasze cienie 3" className="h-full w-full object-cover" />
        </Carousel>
      </div>

      <p className="text-gray-400 text-center px-5 md:px-32 text-base md:text-lg leading-relaxed mt-10">
        Techniką Teatru Cieni zajmujemy się od ponad 20 lat. Wszystko zaczęło się od obejrzenia na kasecie VHS jednego z odcinków programu Jima Hensona — twórcy Muppet Show, w którym pokazywał on lalkarzy z całego świata. Bohaterem programu był Richard Bradshaw — artysta zajmujący się teatrem cieni. Ten prosty i dowcipny teatr Richarda zaczarował nas. W podobnej technice zrobiliśmy spektakle „Romans Perlimplina i Belisy" i „Okienko". Później poznawaliśmy cienie i używaliśmy nowych technik. Powstały spektakle „Sen Rybaka", „Podróż", „Słoń Ptak i…", „Pan Maluśkiewicz". W naszym najnowszym spektaklu „Pieśń rzeki" wcześniej używane techniki teatru cieni i światła wzbogaciliśmy jeszcze o animację oraz przetworzenie zdjęć fotograficznych.
      </p>
    </div>
  );
};

export default Naszteatr;
